import { j as h } from "./react-944c88e2.js";
import { useQueryClient as y, useQuery as m } from "@tanstack/react-query";
import { useState as p, useEffect as f, useCallback as d, useMemo as b, createContext as I } from "react";
import { a as A } from "./domains-162ab8d8.js";
import { u as C } from "./features-4c20b5b5.js";
import { j as v } from "./useAccount-8a1c7225.js";
import "./myasurion-shared.mixpanel.es.js";
import "./contentful-a9b11b75.js";
import "./@firebase-868b0e52.js";
import { H as O, s as F, b as w, f as S } from "./@aws-amplify-21547700.js";
import { D as U } from "./aws-amplify-2a9a372d.js";
const _ = async () => {
  const e = await S() || {};
  return e ? {
    email: e.email,
    emailVerified: e.email_verified,
    name: e.name,
    sub: e.sub,
    providerName: JSON.parse((e == null ? void 0 : e.identities) ?? "")[0].providerName || ""
  } : void 0;
}, D = (e) => {
  const [o, u] = p(), s = y(), { isFeatureOn: l, isFeatureInitialized: t } = C("login-options"), { isLoading: n } = m({
    queryKey: ["user", t],
    queryFn: _,
    enabled: !o && l && t && e,
    onSuccess: (r) => {
      u(r);
    }
  });
  f(() => {
    const r = O.listen("auth", async ({ payload: { event: g, message: a } }) => {
      switch (g) {
        case "signedIn":
        case "signInWithRedirect": {
          s.invalidateQueries(["user"]);
          break;
        }
        case "signedOut":
          s.setQueryData(["user"], void 0);
          break;
        case "signInWithRedirect_failure":
        case "tokenRefresh_failure":
          console.error("Sign in failure", a);
          break;
      }
    });
    return () => {
      r();
    };
  }, []);
  const i = d((r) => {
    F({ provider: r });
  }, []), c = d(() => {
    w();
  }, []);
  return b(
    () => ({
      login: i,
      logout: c,
      user: o,
      isLoading: n
    }),
    [i, c, o, n]
  );
}, x = (e) => {
  console.log("Initialize Cognito Amplify config");
  const {
    // identityPoolId,
    // region,
    userPoolId: o,
    userPoolWebClientId: u,
    domain: s,
    responseType: l,
    signInUrl: t,
    signOutUrl: n
  } = e, i = {
    Auth: {
      Cognito: {
        userPoolId: o,
        userPoolClientId: u,
        storage: sessionStorage,
        loginWith: {
          oauth: {
            domain: s,
            scopes: [
              "email",
              "openid",
              "phone",
              "profile",
              "aws.cognito.signin.user.admin"
            ],
            redirectSignIn: t ? [t] : [`${window.location.origin}/login/sso`],
            redirectSignOut: n ? [n] : [`${window.location.origin}/`],
            responseType: l
          }
        }
      }
    }
  };
  U.configure(i);
}, E = {
  login: () => {
  },
  logout: () => {
  },
  isLoading: !1,
  user: void 0
}, L = I(E), H = ({
  config: e,
  children: o
}) => {
  const [u, s] = p(!1), l = A(), { isFeatureOn: t, isFeatureInitialized: n } = C("login-options"), { data: i, refetch: c } = m({
    queryKey: ["cognitoConfigData"],
    queryFn: () => {
      var g;
      return v(
        e,
        `cognito_config_${l}_${(g = e == null ? void 0 : e.env) == null ? void 0 : g.toLowerCase()}`
      ).then((a) => a ? JSON.parse(a) : null).catch((a) => (console.error("Failed to fetch config ", a), null));
    },
    enabled: !1
  });
  f(() => {
    e && t && c();
  }, [e, n]), f(() => {
    i && (x(i), s(!0));
  }, [i]);
  const r = D(u);
  return /* @__PURE__ */ h.jsx(L.Provider, { value: r, children: o });
};
export {
  H as C,
  L as a,
  D as u
};
